import { useState } from 'react';
import { useLiveRef, useThrottleFn } from '@lumahealthhq/ui-utils';
import useSocketEvents from './useSocketEvents';

/**
 * Subscribe to socket events data and throttle the callback to handle changes at once
 *
 * @param socketEvents Event names we want to subscribe to
 * @param callback Callback to handle the array of datas
 * @param delay
 */
export default function useSocketEventsThrottled(socketEvents, callback, delay = 500) {
  const [array, setArray] = useState([]);

  // Avoid passing unstable reference values into `useEffect` dependency array.
  const onSocketCallback = useLiveRef(callback);
  useThrottleFn(events => {
    if (events.length) {
      onSocketCallback.current([...events]);
      events.splice(0, events.length);
    }
  }, delay, [array]);
  useSocketEvents(socketEvents, (data = {}) => setArray(prev => [...prev, data]));
}